import React, { useEffect, useState } from 'react';
import { AlertTriangle, X } from 'lucide-react';

export default function GlobalDataStatusBanners() {
  const [authError, setAuthError] = useState(null);

  useEffect(() => {
    const onAuthError = (event) => setAuthError(event.detail);

    window.addEventListener('vh-auth-error', onAuthError);

    return () => {
      window.removeEventListener('vh-auth-error', onAuthError);
    };
  }, []);

  if (!authError) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[9999] flex flex-col gap-2 p-3">
      {authError && (
        <div className="bg-red-50 border border-red-200 text-red-800 rounded-lg px-4 py-3 flex items-start gap-3">
          <AlertTriangle className="w-5 h-5 mt-0.5 text-red-600" />
          <div className="flex-1">
            <div className="font-semibold">AUTH ERROR</div>
            <div className="text-sm">
              {authError.message || 'API returned 401/403 - mock fallback disabled for auth failures.'}
            </div>
            {authError.endpoint && (
              <div className="text-xs mt-1 opacity-80">Endpoint: {authError.endpoint}</div>
            )}
          </div>
          <button
            className="text-red-600 hover:text-red-800"
            onClick={() => setAuthError(null)}
            aria-label="Dismiss auth error"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
      )}

    </div>
  );
}
